<script>
  export let assetsPath = '/';
  let width = null;
</script>

<!-- Generated by ai2html v0.100.0 - 2021-09-30 13:49 -->

<div id="g-ai-chart-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 510}
    <div id="g-ai-chart-xs" class="g-artboard" style="">
      <div style="padding: 0 0 91.7004% 0;"></div>
      <div
        id="g-ai-chart-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        )}images/graphics/ai-chart-xs.png);"
      ></div>
    </div>
  {/if}
  <!-- Artboard: sm -->
  {#if width && width >= 510 && width < 660}
    <div id="g-ai-chart-sm" class="g-artboard" style="">
      <div style="padding: 0 0 82.703% 0;"></div>
      <div
        id="g-ai-chart-sm-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        )}images/graphics/ai-chart-sm.png);"
      ></div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660}
    <div id="g-ai-chart-md" class="g-artboard" style="">
      <div style="padding: 0 0 79.6009% 0;"></div>
      <div
        id="g-ai-chart-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        )}images/graphics/ai-chart-md.png);"
      ></div>
    </div>
  {/if}
</div>

<!-- End ai2html - 2021-09-30 13:49 -->

<!-- ai file: ai-chart.ai -->

<!-- svelte-ignore css-unused-selector -->
<style lang="scss">
  #g-ai-chart-box,
  #g-ai-chart-box .g-artboard {
    margin: 0 auto;
  }
  #g-ai-chart-box p {
    margin: 0;
  }
  #g-ai-chart-box .g-aiAbs {
    position: absolute;
  }
  #g-ai-chart-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-ai-chart-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-ai-chart-xs {
    position: relative;
    overflow: hidden;
  }
  #g-ai-chart-sm {
    position: relative;
    overflow: hidden;
  }
  #g-ai-chart-md {
    position: relative;
    overflow: hidden;
  }

  /* Custom CSS */
</style>
